import React from 'react';

function Dashboard() {
  return <div className="tab-content">Dashboard (Inhalt folgt)</div>;
}

export default Dashboard;